import { render, staticRenderFns } from "./customer-service-contact.vue?vue&type=template&id=bec06c4c&"
import script from "./customer-service-contact.vue?vue&type=script&lang=js&"
export * from "./customer-service-contact.vue?vue&type=script&lang=js&"
import style0 from "./customer-service-contact.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bec06c4c')) {
      api.createRecord('bec06c4c', component.options)
    } else {
      api.reload('bec06c4c', component.options)
    }
    module.hot.accept("./customer-service-contact.vue?vue&type=template&id=bec06c4c&", function () {
      api.rerender('bec06c4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apply/approval/customer-service-contact.vue"
export default component.exports